export default {
    parts: [],
    baseStyle: (props) => ({
        img: {
            display: { base: 'block' },
            width: { base: '100%' },
            height: { base: '100%' }
        }
    })
}
